"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _react = require("react");
var _canUseDom = _interopRequireDefault(require("can-use-dom"));
var _FacebookContext = _interopRequireDefault(require("../FacebookContext"));
var _default = function _default(onReady) {
  var _useContext = (0, _react.useContext)(_FacebookContext["default"]),
    handleInit = _useContext.handleInit,
    api = _useContext.api;
  (0, _react.useState)(function _callee() {
    var api2;
    return _regenerator["default"].async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_canUseDom["default"]) {
              _context.next = 5;
              break;
            }
            _context.next = 3;
            return _regenerator["default"].awrap(handleInit());
          case 3:
            api2 = _context.sent;
            if (onReady) {
              onReady(api2);
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }
    });
  });
  return [api, handleInit];
};
exports["default"] = _default;
//# sourceMappingURL=useApi.js.map
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-facebook/lib/hooks/useApi.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-facebook/lib/hooks/useApi.js");
  }
}();